module.exports = __webpack_public_path__ + "static/media/Lacapsule-logo-blanc.9b2f1a28.png";